import React from 'react';
import VideoWidget from './VideoWidget/VideoWidget';
import AddNewVideo from './AddNewVideo/AddNewVideo';
import EditVideo from './EditVideo/EditVideo';
import Alert from '../../../../components/generalComponents/Alert';

import { deleteVideo, updateVideo, uploadVideo } from '../services';

import './VideosGrid.css';
import '../../../../css/utils/flex.css';

class VideosGrid extends React.Component {

  state = {
    menuActive: '',
    modals: {
      addVideo: false
    },
    videoToEdit: null,
    alert: {
      type: '',
      message: ''
    }
  }

  toggleAlert (type, message) {
    this.setState({ alert: { type, message } });
  }

  openWidgetsMenu = id => {
    if (this.state.menuActive === id) {
      this.setState({ menuActive: '' })
    } else {
      this.setState({ menuActive: id })
    }
  }

  toggleVideoModal = flag => {
    const modals = { ...this.state.modals, addVideo: flag };
    this.setState({ modals });
  }

  deleteVideo = videoId => {
    const { user: { account: { anchor: { id } } }, getVideos } = this.props;
    deleteVideo({ id, videoId })
      .then(() => {
        getVideos();
      })
  }

  passVideoForEditing = video => {
    this.setState({ videoToEdit: video });
  }

  editVideo = data => {
    const { user: { account: { anchor: { id } } }, getVideos } = this.props;
    const { videoId } = this.state.videoToEdit;
    updateVideo({ id, videoId, data: { ...data, anchorId: id, videoId } })
      .then(() => {
        this.passVideoForEditing(null);
        getVideos();
      })
  }

  uploadVideo = async (data, onUploadProgress) => {
    const { user: { account: { anchor: { id } } }, getVideos } = this.props;
    try {
      await uploadVideo({
        id,
        data: { title: data.title, description: data.description },
        video: data.video[0],
        onProgress: onUploadProgress
      });
      this.toggleVideoModal(false);
      this.toggleAlert('success', 'Video has been added.');
      getVideos();
    } catch (error) {
      this.toggleVideoModal(false);
      this.toggleAlert('error', 'Video was not added.');
    }
  }

  render () {
    const { videos } = this.props;
    const { menuActive, modals, videoToEdit, alert } = this.state;
    return (
      <>
        {alert.type && alert.message && (
          <Alert onClose={() => this.toggleAlert()} type={alert.type}>
            {this.state.alert.message}
          </Alert>
        )}
        {modals.addVideo && (
          <AddNewVideo
            toggleVideoModal={this.toggleVideoModal}
            uploadVideo={this.uploadVideo}
          />
        )}
        {videoToEdit && (
          <EditVideo
            video={videoToEdit}
            editVideo={this.editVideo}
            onClose={this.passVideoForEditing}
          />
        )}
        <div id="anchor-video-archive-grid">
          <button
            className="btn btn-danger upload-video"
            onClick={() => this.toggleVideoModal(true)}>
            Add new video
          </button>
          <div className="row-r">
            {videos.map(video => (
              <VideoWidget
                passVideoForEditing={this.passVideoForEditing}
                deleteVideo={this.deleteVideo}
                key={video.videoId}
                video={video}
                toggleMenu={this.openWidgetsMenu}
                menuActive={menuActive === `${video.videoId}`}
              />
            ))}
          </div>
        </div>
      </>
    );
  }
}

export default VideosGrid;